import script from "./simplePageSideNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./simplePageSideNavigation.vue?vue&type=script&setup=true&lang=js"

import "./simplePageSideNavigation.vue?vue&type=style&index=0&id=37b945f8&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b945f8"]])

export default __exports__